import React from "react";
import { Colors } from "../../config/Constants";
import {
  ChangePinIcon,
  ProfileIcon,
  EntitlementIcon,
  DashboardIcon,
  BookingStatusIcon,
  LogoutIcon,
  FaqIcon,
} from "./IconsList";

const Icon = ({ path, isActivePath }) => {
  const fill1 = isActivePath ? Colors.brandTwo : Colors.white;
  const fill2 = isActivePath ? Colors.white : Colors.brandTwo;

  const getIcon = (path) => {
    switch (path) {
      case "dashboard":
        return <DashboardIcon fill1={fill1} fill2={fill2} />;
      case "bookings":
        return <BookingStatusIcon fill1={fill1} fill2={fill2} />;
      case "profile":
        return <ProfileIcon fill1={fill1} fill2={fill2} />;
      case "pin":
        return <ChangePinIcon fill1={fill1} fill2={fill2} />;
      case "entitlements":
        return <EntitlementIcon fill1={fill1} fill2={fill2} />;
      case "logout":
        return <LogoutIcon fill1={fill1} fill2={fill2} />;
        case "faqs":
          return <FaqIcon fill1={fill1} fill2={fill2} />;
      default:
        return <DashboardIcon fill1={fill1} fill2={fill2} />;
    }
  };
  return <>{getIcon(path, isActivePath)}</>;
};

export default Icon;
